var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vld-parent"},[_c('loading',{attrs:{"active":_vm.dialogPrincipal,"can-cancel":_vm.cancel,"color":_vm.color,"is-full-page":_vm.fullPage,"loader":_vm.loader,"width":_vm.width,"enforce-focus":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }